/**
 * Linear interpolation (mix)
 * @param i Start value
 * @param j End value
 * @param t Percentage value between 0 and 1
 * @returns A number between the start and end values corresponding to the percentage
 */
export function lerp(i, j, t) {
  return i + (j - i) * t;
}

/**
 * Clamps a value within a domain
 * @param value The number to be clamped
 * @param minVal The minimum value the result can be
 * @param maxVal The maximum value the result can be
 * @returns A number that follows the value but clamped at minVal and maxVal
 */
export function clamp(value: number, minVal: number, maxVal: number) {
  return Math.max(minVal, Math.min(maxVal, value));
}

/**
 * Interpolates two points to extract an arbitrary value from the x domain
 * @param x0 The x of the first point
 * @param y0 The y of the first point
 * @param x1 The x of the second point
 * @param y1 The y of the second point
 * @param x A point in the x domain
 * @returns A value in the y domain
 */
export function interpolate(x0: number, y0: number, x1: number, y1: number, x: number) {
  return (x1 === x0) ? y0 : lerp(y0, y1, (x - x0) / (x1 - x0));
}
